<script>
  import { onDestroy, onMount } from 'svelte';

  import { fade } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';

  import Panel from './_Panel.svelte';
  import helpIcon from './helpIcon.svg';

  import {
    helpPanelShow,
    helpPanelOpen,
    track,
    trackingEvents
  } from '../../store/index.js';

  let panel = undefined;

  onMount(() => {
    window.onhashchange = () => {
      $helpPanelShow = false;
      $helpPanelOpen = false;
    };
  });

  function handlePanelOpen() {
    if (panel) { 
      return $helpPanelOpen = true; 
    }

    panel = new Panel({
      target: document.querySelector('body')
    });

    $helpPanelOpen = true;

    track(trackingEvents.HELP_PANEL_OPENED);
  }

  onDestroy(() => {
    if (panel) panel.$destroy();
  });
</script>

{#if $helpPanelShow}
<div class="cta" on:click="{handlePanelOpen}" transition:fade="{{duration: 300, easing: quintOut}}">
  <span>Help Centre</span>
  <img src="{ helpIcon }" alt="Help" class="helpIcon">
</div>
{/if}

<style>
  .cta {
    display: none;
    color: #3F4F5F;
    font-size: 14px;
    letter-spacing: -0.15px;
    line-height: 20px;
    position: relative;
    border-bottom: 1px solid #d8dbdf;
  }

  .cta span {
    padding: 0 16px;
    line-height: 48px;
  }

  .cta:hover {
    background: #e7f2ff;
    cursor: pointer;
  }

  .helpIcon {
    width: 20px;
    height: 24px;
    position: absolute;
    top: 12px;
    right: 14px;
  }

  @media (min-width: 992px) {
    .cta {
      display: flex;
    }
  }
</style>
